import React from "react";
import { useDispatch } from "react-redux";
import { createChat } from "../../../actions/chat";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers } from "@fortawesome/pro-solid-svg-icons";
import { isEmpty } from "lodash";

const ICON_LOOKUP = {
  member: faUser,
  group: faUsers,
};

type TileArgs = {
  id: string;
  name: string;
  type: string;
  profile_image?: string;
  images?: { small: string };
};

export default function Tile({
  id,
  name,
  type,
  images,
  profile_image,
}: TileArgs) {
  const dispatch = useDispatch();

  console.log("GOT SOME MORE INFO?", images, profile_image);

  function onCreateChat(e) {
    e.preventDefault();
    dispatch(createChat({ payload: { id, type } }));
  }
  return (
    <button
      key={id}
      onClick={onCreateChat}
      className={classnames(
        "chat__new_chat_button flex px-3 py-2 justify-start text-sm items-center gap-1",
        {
          memberChat: type === "member",
          groupChat: type === "group",
        },
      )}
    >
      {profile_image && (
        <img className="rounded-full w-6 h-6" src={profile_image} alt={name} />
      )}
      {images && !isEmpty(images) && (
        <img alt={name} className="rounded-full w-6 h-6" src={images.small} />
      )}
      {isEmpty(profile_image) && isEmpty(images) && (
        <FontAwesomeIcon
          className="text-muted w-6 aspect-square"
          icon={ICON_LOOKUP[type]}
        />
      )}
      {name}
    </button>
  );
}
